<script>
import {Bar, Line} from 'vue-chartjs'
import API from "@/api/analytics";

export default {
  extends: Bar,
  props: ['daterange', 'actions', 'groups'],
  data() {
    return {
      eventCountsByActionTypeByDay: { },
      eventTemps: { }
    }
  },
  computed: {
    chartData: function() {
      return {
        labels: this.labels,
        datasets: [
          {
            type: 'line',
            label: this.$t('Analysis.max_temp'),
            borderColor: '#CC3300',
            backgroundColor: '#CC3300',
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 5,
            showLine: true,
            fill: false,
            data: this.countsForEnv('max_temp'),
            yAxisID: 'line-temp'
          },
          {
            type: 'line',
            label: this.$t('Analysis.min_temp'),
            borderColor: '#f9d8cc',
            backgroundColor: '#f9d8cc',
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 5,
            showLine: true,
            fill: false,
            data: this.countsForEnv('min_temp'),
            yAxisID: 'line-temp'
          },
          {
            type: 'line',
            label: this.$t('Analysis.ave_humidity'),
            borderColor: '#0033FF',
            backgroundColor: '#0033FF',
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 5,
            showLine: true,
            fill: false,
            data: this.countsForEnv('average_humidity'),
            yAxisID: 'line-humidity'
          },
          {
            type: 'line',
            label: this.$t('Analysis.ave_pressure'),
            borderColor: '#999',
            backgroundColor: '#999',
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 5,
            showLine: true,
            fill: false,
            data: this.countsForEnv('average_pressure'),
            yAxisID: 'line-pressure'
          },
          {
            label: this.$t('Cuona.Event.event01'),
            borderColor: '#009CE1',
            borderWidth: 1.5,
            backgroundColor: '#009CE1',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#009CE1',
            data: this.countsForEvent('checkin'),
            yAxisID: 'bar-1'
          },
          {
            label: this.$t('Cuona.Event.event03'),
            borderColor: '#47B7E9',
            borderWidth: 1.5,
            backgroundColor: '#47B7E9',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#47B7E9',
            data: this.countsForEvent('checkout'),
            yAxisID: 'bar-1'
          },
          {
            label: this.$t('Cuona.Event.event04'),
            borderColor: '#6BC5EE',
            borderWidth: 1.5,
            backgroundColor: '#6BC5EE',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#6BC5EE',
            data: this.countsForEvent('public_url'),
            yAxisID: 'bar-1'
          },
          {
            label: this.$t('Cuona.Event.event05'),
            borderColor: '#7FCDF0',
            borderWidth: 1.5,
            backgroundColor: '#7FCDF0',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#7FCDF0',
            data: this.countsForEvent('custom_url'),
            yAxisID: 'bar-1'
          },
          {
            label: this.$t('Cuona.Event.event06'),
            borderColor: '#B2E1F6',
            borderWidth: 1.5,
            backgroundColor: '#B2E1F6',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#B2E1F6',
            data: this.countsForEvent('favor'),
            yAxisID: 'bar-1'
          },
          {
            label: this.$t('Cuona.Event.event_other'),
            borderColor: '#EEEEEE',
            borderWidth: 1.5,
            backgroundColor: 'rgba(0,0,0,0.1)',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: 'rgba(0,0,0,0.1)',
            data: this.countsForEvent('_unknown'),
            yAxisID: 'bar-1'
          }
        ]
      }
    },
    labels: function() {
      return Object.keys(this.eventCountsByActionTypeByDay).sort();
    }
  },
  mounted() {
    let obj = this;
    this.options = {
      legend: {
        position: "bottom"
      },
      onClick: function(evt, item){
        let el = this.getElementAtEvent(evt);
        if (el && el[0] && el[0]['_index'] ) {
          obj.$emit('changeGraph', obj.labels[el[0]['_index']]);
        }
      },
      tooltips: {
        mode: 'index',
        intersect: false
      },
      hover: {
        mode: 'index',
        intersect: true
      },
      scales: {
        xAxes: [{
          stacked: true,
          callback: {
            beforeUpdate: function(axis) {
              console.log(axis)
            }
          },
          gridLines: {
            display: false
          },
          ticks: {
            fontColor: "#999",
            // callback: function(value, index, values){
            //   return value.replace(/20[0-9]{2}\//g, "")
            // }
          }
        }],
        yAxes: [{
          id: 'line-temp',
          stacked: false,
          position: "right",
          ticks: {
            min: -10,
            max: 50,
            fontColor: "#999"
          },
          gridLines: {
            drawOnChartArea: false,
          },
          scaleLabel: {
            display: true,
            labelString: this.$t('Cuona.Device.temperature'),
            fontSize: 12,
            position: 'top'
          }
        },
        {
          id: 'line-humidity',
          stacked: false,
          position: "right",
          ticks: {
            min: 0,
            max: 100,
            fontColor: "#999"
          },
          gridLines: {
            drawOnChartArea: false,
          },
          scaleLabel: {
            display: true,
            labelString: this.$t('Cuona.Device.humidity'),
            fontSize: 12,
            position: 'top'
          }
        },
        {
          id: 'line-pressure',
          stacked: false,
          position: "right",
          ticks: {
            min: 900,
            max: 1100,
            fontColor: "#999"
          },
          gridLines: {
            drawOnChartArea: false,
          },
          scaleLabel: {
            display: true,
            labelString: this.$t('Cuona.Device.pressure'),
            fontSize: 12,
            position: 'top'
          }
        },
        {
          id: 'bar-1',
          stacked: true,
          ticks: {
            min: 0,
            fontColor: "#999"
          },
          scaleLabel: {
            display: true,
            labelString: this.$t('Analysis.Device.total_count'),
            fontSize: 12,
            position: 'top'
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      spanGaps: true,
      elements: {
        line: {
          tension: 0
        }
      },
      plugins: {
        datalabels: {
          display: false
        }
      }
    };
    this.updateData();
  },
  methods: {
    updateData() {
      const obj = this;
      const reqParams = {
        nfc_uid: this.$route.params.nfc_uid,
        daterange: this.daterange,
        action_types: this.actions,
        groups: this.groups
      };
      Promise.all([API.getEventCountsByActionType(reqParams), API.getEventTemps(reqParams)]).then(function(responses) {
        if (responses[0] && responses[0].event_counts) {
          obj.eventCountsByActionTypeByDay = responses[0].event_counts;
        } else {
          obj.eventCountsByActionTypeByDay = { };
        }
        if (responses[1] && responses[1].event_temps) {
          obj.eventTemps = responses[1].event_temps;
        } else {
          obj.eventTemps = { };
        }
        obj.renderChart(obj.chartData, obj.options);
      });
    },
    countsForEvent: function(action) {
      return this.labels.map(date => this.eventCountsByActionTypeByDay[date][action] || 0);
    },
    countsForEnv(element) {
      return this.labels.map(date => Math.round((this.eventTemps[date] && this.eventTemps[date][element])*100)/100 || null);
    }
  },
  watch : {
    daterange() {
      this.updateData();
    },
    actions() {
      this.updateData();
    },
    groups() {
      this.updateData();
    }
  }
}
</script>
